
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface BtnProps {
    to?: ReactRouterDom.To;
    href?: string;
    target?: string;
    size?: "sm" | "md" | "lg";
    children: React.ReactNode;
    style?: React.CSSProperties;
    variant?: "primary" | "outline" | "text";
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

function Btn({ children, variant = "primary", size = "md", to, href, target, onClick, style }: BtnProps) {

    const className = Classname.build(styles["btn"], styles[`btn-${variant}`], styles[`btn-${size}`]);
    const content = (<>
        <span className={styles["btn-label"]}>{children}</span>
        {variant === "text" && (<i className={Classname.build("fa fa-arrow-right", styles["btn-arrow"])} />)}
    </>);

    if (to) {
        return (<ReactRouterDom.NavLink end to={to} target={target} className={className} style={style} onClick={onClick}>{content}</ReactRouterDom.NavLink>);
    }
    if (href) {
        return (<a href={href} target={target} className={className} style={style} onClick={onClick}>{content}</a>);
    }
    return (<button className={className} style={style} onClick={onClick}>{content}</button>);
}

export default Btn;
